'use client';

import { FC, ReactNode, Suspense } from 'react';
import { AppbarSkeleton } from './skeleton';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import dynamic from 'next/dynamic';

const AppbarContent = dynamic(() =>
  import('./content').then((mod) => mod.AppbarContent)
);

export const Appbar: FC<{ leftSidebarContent: ReactNode }> = ({
  leftSidebarContent,
}) => {
  const { isHydrated } = useResponsive();
  if (!isHydrated) return <AppbarSkeleton />;
  return (
    <Suspense fallback={<AppbarSkeleton />}>
      <AppbarContent leftSidebarContent={leftSidebarContent} />
    </Suspense>
  );
};
